import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import Reveal from "./Reveal";

const STATUS_MESSAGES = [
  "Available for new opportunities",
  "Open to freelance projects & full-time roles",
  "Let's build something intelligent together",
];

const OpportunityTicker = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % STATUS_MESSAGES.length);
        setVisible(true);
      }, 300);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative mx-auto max-w-2xl text-center">
            <div className="glow-border inline-flex items-center gap-3 px-6 py-3 rounded-full bg-card/60 backdrop-blur-sm text-foreground/90">
              <span className="relative flex h-2 w-2 shrink-0">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
              </span>
              <span className="inline-flex items-center gap-2 text-sm md:text-base font-medium">
                <Sparkles
                  size={14}
                  className="text-primary flex-shrink-0"
                />
                <span
                  key={index}
                  className={`inline-block transition-all duration-300 ${
                    visible ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"
                  }`}
                >
                  {STATUS_MESSAGES[index]}
                </span>
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default OpportunityTicker;